module.exports = __webpack_public_path__ + "static/img/10.27f9306.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/3Dmodeling/10.jpg
// module id = F28F
// module chunks = 1